import { render, staticRenderFns } from "./BarConsultationsISTByLocalisationsDouleursOnlyAT.vue?vue&type=template&id=7f3bccbe&"
import script from "./BarConsultationsISTByLocalisationsDouleursOnlyAT.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByLocalisationsDouleursOnlyAT.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports